import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router';
import Drawing from '/@/components/drawing';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const NitrogenRecommendationSuccess = ({ id }) => {
    const history = useNavigate();
    return (
        <Grid container direction='column' justifyContent='center' sx={{ gap: 2, p: 2, height: '100%' }}>
            <Grid item>
                <Drawing
                    size='sm'
                    type='success-corn'
                    title={<span style={{ fontWeight: 800 }}>{_('Solicitud enviada con éxito')}</span>}
                    subtitle={_(
                        'Te notificaremos cuando se acerque la fecha de siembra y de re-fertilización indicada para que nos confirmes y así poder procesar tus datos correctamente.'
                    )}
                />
            </Grid>
            <Grid item>
                <Button
                    variant='outlined'
                    onClick={() =>
                        history(
                            reverse('nitrogenRecommendation.NitrogenRecommendationDetail', {
                                params: { id },
                            })
                        )
                    }
                >
                    {_('Ver recomendación N-Smart generada')}
                </Button>
            </Grid>
            <Grid item>
                <Button
                    variant='outlined'
                    onClick={() => {
                        history(reverse('nitrogenRecommendation.NitrogenRecommendationList'));
                    }}
                >
                    {_('Continuar navegando')}
                </Button>
            </Grid>
        </Grid>
    );
};

export default NitrogenRecommendationSuccess;
